<template>
  <div class="van-page">
    <the-header title="项目" />
    <gz-footer></gz-footer>
    <van-sticky>
      <van-search class="search-box" v-model="keyword" placeholder="项目名称" shape="round" />
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDataList">
      <div class="van-section" v-for="(item, index) in listData" :key="index" @click="handleItem(item)" ref="project">
        <div class="van-section__state">
          <div class="state-tag state-tag__success" v-if="item.state === '0'">正常</div>
          <div class="state-tag state-tag__warning" v-if="item.state === '1'">预警</div>
          <div class="state-tag state-tag__danger" v-if="item.state === '2'">超时</div>
        </div>
        <div class="van-section__header">
          <div class="van-section__title">{{ item.PROJECT_NAME }}</div>
        </div>
        <div class="van-section__body">
          <ul class="list-group">
            <li>
              <span class="label">项目编码</span>
              <span style="color: #42444D;">{{ item.PROJECT_CODE }}</span>
            </li>
            <li>
              <span class="label">项目单位</span>
              <span>{{ item.OWNER_COMPANY }}</span>
            </li>
          </ul>
          <div class="progress-bar">
            <span>进度</span>
            <van-progress :percentage="100" :show-pivot="false" stroke-width="6" track-color="#DFE2ED"
              color="linear-gradient(to right, #97B8FF, #427AF4)" />
            <span>{{ 100 }}%</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
  
<script>
import moment from 'moment'
import _ from 'lodash';
import { getProjectByUserId } from '@/api/interface/project'
export default {
  components: {
    'the-header': () => import('@/components/TheHeader'),
    'gz-footer': () => import('@/components/GzFooter'),
  },
  data() {
    return {
      keyword: '',
      isFilterShow: false,
      pageNo: 1,
      // 区划
      loading: false,
      finished: false,
      isShowRegion: false,
      regionRadio: [
        { id: 'all', name: '全市' },
        { id: '2', name: '威海市' },
        { id: '3', name: '文登' },
        { id: '4', name: '环翠' },
        { id: '5', name: '乳山' },
        { id: '6', name: '威海市' },
        { id: '7', name: '威海市' },
        { id: '8', name: '威海市' },
        { id: '9', name: '威海市' },
        { id: '10', name: '威海市' },
      ],
      // 受理时间
      isCalendarAcceptance: false,
      // 办结
      isCalendarCompleted: false,
      isShowStage: false,
      stageRadio: [
        { id: '1', name: '立项用地规划许可' },
        { id: '2', name: '建设许可' },
        { id: '3', name: '建设许可' },
        { id: '4', name: '建设许可' },
        { id: '5', name: '建设许可' },
        { id: '6', name: '建设许可' },
        { id: '7', name: '建设许可' },
        { id: '8', name: '建设许可' },
        { id: '9', name: '建设许可' },
        { id: '10', name: '建设许可' },
      ],
      listData: [],
    }
  },
  methods: {
    getDataList() {
      const user = this.$store.getters.getUser
      const instance = new getProjectByUserId({
        userId: user.postType == 'KY' ? user.userId : '',
        regionCode: user.postType == 'KZ' ? user.regionCode : '',
        page: this.pageNo++,
        rows: window.config.pageSize,
        projectName: this.keyword
      })
      instance
        .then((result) => {
          const data = JSON.parse(result.data.majorProjectData)
          if (data.length > 0) {
            this.listData = this.listData.concat(data)
            this.loading = false
            this.finished = false
          } else {
            this.loading = false
            this.finished = true
            this.$dialog.alert({
              message: '没有更多数据了'
            })
          }
          if (data.length < window.config.pageSize) {
            this.finished = true
          }
        }).catch((err) => {
          console.log(err);
          this.$dialog.alert({
            message: '请求失败请联系开发人员'
          })
          this.loading = false
          this.finished = true
        });
    },
    // 受理时间自定义
    handleAcceptanceConfirm(date) {
      const [start, end] = date
      this.isCalendarAcceptance = false
      this.formFilter.acceptanceRange = moment(start).format('YYYY-MM-DD') + ' - ' + moment(end).format('YYYY-MM-DD')
    },
    // 办结自定义
    handleCompletedConfirm(date) {
      const [start, end] = date
      this.isCalendarCompleted = false
      this.formFilter.completedRange = moment(start).format('YYYY-MM-DD') + ' - ' + moment(end).format('YYYY-MM-DD')
    },
    // 受理时间
    changeAcceptance(e) {
      if (e !== '3') {
        this.formFilter.acceptanceRange = ''
      }
    },
    changeCompleted(e) {
      if (e !== '3') {
        // this.isCalendarCompleted = true
        this.formFilter.completedRange = ''
      }
    },
    // 重置
    handleFilterClear() {
      this.formFilter.all = 'all'
      this.formFilter.status = 'all'
      this.formFilter.acceptance = 'all'
      this.formFilter.acceptanceRange = ''
      this.formFilter.completed = 'all'
      this.formFilter.completedRange = ''
      this.formFilter.paralleling = '0'
      this.formFilter.stage = '1'
    },
    // 确定
    handleFilterSubmit() {
      this.isFilterShow = false
    },
    handleItem(item) {
      this.$router.push({ path: '/projectDetail', query: { projectCode: item.PROJECT_CODE, seqId: item.SEQ_ID } });
    }
  },
  mounted() {
    this.getDataList()
  },
  watch: {
    keyword: {
      handler: _.debounce(function (newVal) {
        this.pageNo = 1
        this.listData = []
        this.getDataList()
      }, 500),
      immediate: true
    }
  },
}
</script>
  
<style lang="less" scoped>
.van-page {
  padding-bottom: 60px;
}

.van-container {
  padding: 12px 16px;
}

.search-box {
  .van-search__content {
    border: 1px solid #EAEBEE;
    background: #fff;
  }
}

.van-filter {
  background: #fff;
  padding: 0 12px 16px;
  display: flex;
  align-items: center;

}

.van-filter__left {
  flex: 1;
  overflow-x: auto;

  .btn-group {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;

  }
}

::v-deep {
  .van-dropdown-menu__bar {
    height: 32px;
  }

  .van-dropdown-menu__item {
    background: #F3F3F4;
    flex: none;
    padding-right: 15px;

    &+.van-dropdown-menu__item {
      margin-left: 8px;
    }
  }

  .van-dropdown-menu__title {
    font-size: 12px;

    &:after {
      border-color: transparent transparent #BDBFC6 #BDBFC6;
    }
  }

  .van-btn-gray {
    background: #F3F3F4;
    border: 0;
    margin-right: 6px;
    padding: 0 7px;

    &:last-child {
      margin-right: 0;
    }

    .van-icon {
      color: #BDBFC6;
    }
  }
}

.popup-header {
  padding: 12px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &+.popup-body {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.popup-body {
  padding: 12px 12px;
}

.text-range {
  font-size: 12px;
}

::v-deep {
  .van-radio-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: -4px -4px 4px -4px;

    .van-radio {
      padding: 4px;
      width: 25%;
      overflow: hidden;

      .van-radio__label {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
        margin: 0;
        text-align: center;
        background-color: #F3F3F4;
        font-size: 12px;
        border-radius: 2px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      .van-radio__icon {
        display: none;

        &.van-radio__icon--checked+.van-radio__label {
          color: #427AF4;
          background: #E3EFFF;
        }
      }
    }
  }
}

.popup-main {
  overflow: auto;
  // flex: 1;
  height: calc(100% - 70px);
  // padding-bottom: 20px;
}

.popup-footer {
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #E7E7E7;
  display: flex;
  gap: 10px;
}

.open-more {
  font-size: 12px;
}

.van-section {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 6px;
  position: relative;
}

.van-section__state {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
  font-size: 12px;
}

.state-tag {
  padding: 4px 6px;
  border-radius: 0px 6px 0px 2px;
  color: #fff;
}

.state-tag__success {
  background: #27AD5D;
}

.state-tag__warning {
  background: #F49609;
}

.state-tag__danger {
  background: #ED5B56;
}

.van-section__header {
  padding: 16px 12px;
  padding-right: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.van-section__title {
  font-size: 16px;
  font-weight: 600;
}

.van-section__body {
  padding: 12px;
  padding-top: 0;
}

// .van-section__footer{
//   padding: 12px;
// }
.list-group {
  font-size: 14px;

  >li {
    color: #868A93;

    &+li {
      margin-top: 6px;
    }
  }

  .label {
    // color: #868A93;
    width: 70px;
    display: inline-block;
  }
}

.progress-bar {
  display: flex;
  margin-top: 12px;
  align-items: center;
  font-size: 14px;
  gap: 12px;

  .van-progress {
    flex: 1;
  }
}
</style>